// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { Fragment } from "react";
import { connect } from "react-redux";
import {
  AuthDiv,
  AuthFormHeader,
  Button,
  ContainerLeftAligned,
} from "src/styles/auth";

import { getSignInEmail } from "src/reducers";
import type { AppState } from "src/types";
import { continueToApp } from "src/actions/auth";
import NavLinks from "src/components/auth/NavLinks";

type Props = {
  email: string,
  continueToApp: Function,
};

const ResetSuccessComponent = ({ email, continueToApp }: Props) => (
  <Fragment>
    <AuthDiv>
      <AuthFormHeader>{i18n.t(k.PASSWORD_CHANGE_SUCCESSFUL)}</AuthFormHeader>
      <ContainerLeftAligned>
        <div>{i18n.t(k.YOUR_PASSWORD_HAS_BEEN_RESET_S)}</div>
        <b>{email}</b>
      </ContainerLeftAligned>
      <Button onClick={() => continueToApp()}>
        {i18n.t(k.CONTINUE_TO_YOUR_UNIFIZE_APP)}
      </Button>
    </AuthDiv>
    <NavLinks />
  </Fragment>
);

const mapStateToProps = ({ app }: { app: AppState }) => ({
  email: getSignInEmail(app),
});

const ResetSuccess = connect(mapStateToProps, {
  continueToApp,
})(ResetSuccessComponent);

export default ResetSuccess;
